import { createContext, useContext } from 'react'

/** The signed-in tenant, as extensions see it. */
export interface TenantInfo {
    slug: string
    name: string
    /** A sales demo: label exports and screens as sample data. */
    demo: boolean
}

export const TenantContext = createContext<TenantInfo | null>(null)

/** The signed-in tenant (SDK 1.1). Null outside the signed-in layout. */
export function useTenant(): TenantInfo | null {
    return useContext(TenantContext)
}
